import { SimpleResult } from "./results/SimpleResult";

interface AIToolResultProps {
  result: string;
}

export const AIToolResult = ({ result }: AIToolResultProps) => {
  return <SimpleResult content={result} />;
};